// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function debounce<Params extends any[]>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  func: (...args: Params) => any,
  timeout: number
): (...args: Params) => void {
  let timer: NodeJS.Timeout
  return (...args: Params) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func(...args)
    }, timeout)
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function throttle<Params extends any[]>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  func: (...args: Params) => any,
  timeout: number
): (...args: Params) => void {
  let wait = false
  return (...args: Params) => {
    if (!wait) {
      func(...args)
      wait = true
      setTimeout(function () {
        wait = false
      }, timeout)
    }
  }
}
